import axios from "@lib/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export interface Inputs {
  name: string;
  active?: boolean;
}

interface UseSavePLProps {
  plId?: string;
  onSuccess?: (data: AxiosResponse) => void;
  onError?: (error: AxiosResponse) => void;
}

export const useSavePL = ({ plId, onSuccess, onError }: UseSavePLProps) => {
  const queryClient = useQueryClient();
  const {
    isPending,
    isError,
    error,
    mutate: onSavePL,
  } = useMutation({
    mutationFn: async (data: Inputs) => {
      if (plId) return axios.patch(`/pls/${plId}`, data);
      return axios.post("/pls", data);
    },
    onSuccess: (data) => {
      if (plId)
        queryClient.invalidateQueries({
          queryKey: ["pls", plId],
        });
      if (onSuccess) onSuccess(data);
    },
    onError,
  });

  return { onSavePL, isPending, isError, error };
};
